import { LevelAbbreviations } from "../Types";

export const FiasMunicipalDistrictTypes: LevelAbbreviations[] = [
    {
        long: "Муниципальный район",
        short: "м.р-н",
        fiasKey: "1",
    },
    {
        long: "Городской округ",
        short: "г.о.",
        fiasKey: "2",
    },
    {
        long: "Внутригородская территория города федерального значения",
        short: "вн.тер.г.",
        fiasKey: "3",
    },
    {
        long: "Муниципальный округ",
        short: "м.о.",
        fiasKey: "4",
    },
    {
        long: "Федеральная территория",
        short: "ф.т.",
        fiasKey: "5",
    },
];
